import styled from "styled-components";

const HeadingTwo = styled.h2`
  font-size: 38px;
  text-align: center;
  font-family: montserrat;
`;

export default HeadingTwo;
